
import { useNavigate } from 'react-router-dom';

export const useHomePageHandlers = () => {
  const navigate = useNavigate();

  const handleResultsLeagueSelect = (
    setResultsLeague: (league: string | null) => void
  ) => (league: string) => {
    console.log("Results league selected:", league);
    setResultsLeague(league);
    return league; // Return the league to match the expected return type
  };
  
  const handleCountrySelect = (setSelectedCountry: (country: string) => void) => (country: string) => {
    console.log("Home page country selected:", country);
    setSelectedCountry(country);
  };
  
  const handleTabChange = (value: string) => {
    if (value === "latest") {
      console.log('Latest tab clicked');
      navigateToLatestResults();
    }
  };
  
  const navigateToLatestResults = () => {
    navigate('/results', {
      state: {
        loadLatest: true,
        findLatestDate: true
      }
    });
  };
  
  const handleLatestClick = () => {
    navigateToLatestResults();
  };

  return {
    handleResultsLeagueSelect,
    handleCountrySelect,
    handleTabChange,
    handleLatestClick
  };
};
